module.exports = __webpack_public_path__ + "static/media/css3.79afcf47.svg";